module.exports = __webpack_public_path__ + "img/xaas-twitter.8bdcb39.png";